/**
 * Slack Batch Approval API helpers
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
const getAdminToken = () => 'dev';

/**
 * Request Slack approval for multiple traces in batch
 * Rate limited to prevent spam
 */
export async function requestSlackApprovalBatch({ 
  teamId, 
  brandId, 
  traceIds, 
  channelId,
  maxPerMinute = 15 
}) {
  const res = await fetch(
    `${API_BASE}/api/v1/integrations/slack/send-approval/batch`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Admin-Token': getAdminToken()
      },
      body: JSON.stringify({
        team_id: teamId || undefined,
        brand_id: brandId,
        trace_ids: traceIds,
        channel_id: channelId || undefined,
        max_per_minute: maxPerMinute
      })
    }
  );
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to send batch approval requests');
  }
  
  return res.json();
}
